import { hmac } from './hmac';
import fetch, { RequestInit } from 'node-fetch';
import { Error } from '../types';

/**
 * Utility function to call BSP Endpoint with HMAC Encryption
 * Derived from: https://developer.ncr.com/portals/dev-portal/help-center/documentation/254
 * @param {string} secretKey BSP Secret Key.
 * @param {string} sharedKey BSP Shared Key.
 * @param {string} organization BSP Organization.
 * @param {string} url BSP Request URL.
 * @param {string} method HTTP Method (GET, POST, etc).
 * @param {string} [body] Body for API call.
 * @return {unknown|Error.Error}
 */
export async function callBsp(
  secretKey: string,
  sharedKey: string,
  organization: string,
  url: string,
  method: string,
  body?: unknown
): Promise<Error.Error | unknown> {
  const date = new Date(); // initialize our date

  const options = {
    date,
    secretKey,
    sharedKey,
    nepOrganization: organization,
    requestURL: url,
    httpMethod: method,
    contentType: 'application/json',
  };

  const hmacAccessKey = hmac(options);

  const requestOptions: RequestInit = {
    method: options.httpMethod,
    headers: {
      'Content-Type': options.contentType,
      'Authorization': `AccessKey ${hmacAccessKey}`,
      'nep-organization': options.nepOrganization,
      'Date': date.toUTCString(),
    },
  };

  if (body) {
    requestOptions['body'] = JSON.stringify(body);
  }

  return fetch(options.requestURL, requestOptions)
    .then((response) => response.json())
    .catch((err) => err);
}
